/**
 * LERA Product Card — Conversion Layer CTA (delegated, single init)
 * Adds first available variant to cart via Dawn cart drawer.
 */
(function initLeraProductCard() {
  if (window.__leraProductCardInit) return;
  window.__leraProductCardInit = true;

  document.addEventListener('click', onCtaClick);

  async function onCtaClick(event) {
    const button = event.target.closest('button.lera-product-card__cta[data-variant-id]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const spinner = button.querySelector('.lera-product-card__cta-spinner');

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('lera-product-card__cta--loading');
    if (spinner) spinner.hidden = false;

    let keepDisabled = button.dataset.soldOut === 'true';

    try {
      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(button);
        }
      }

      config.body = formData;

      const response = await fetch(`${window.routes.cart_add_url}`, config);
      const data = await response.json();

      if (data.status) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'lera-product-card',
            productVariantId: variantId,
            errors: data.errors || data.description,
            message: data.message,
          });
        }
        return;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'lera-product-card',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      }

      if (cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    } catch (error) {
      console.error('[lera-product-card]', error);
    } finally {
      button.classList.remove('lera-product-card__cta--loading');
      if (spinner) spinner.hidden = true;
      if (!keepDisabled) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
    }
  }
})();
